import request from "@/utils/request";

export function companyProductPojoList(params) {
  return request({
    url: "companyProduct/web/companyProductPojoList",
    method: "get",
    params,
  });
}
//企业产品详情
export function companyProductPojoDetails(params) {
  return request({
    url: "companyProduct/web/companyProductPojoDetails",
    method: "get",
    params,
  });
}
//企业产品添加到购物车
export function addProductShoppingCart(data) {
  return request({
    url: "productShoppingCart/web/addProductShoppingCart",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}
//地址
export function userAddressPojoList(params) {
  return request({
    url: "userAddress/userAddressPojoList",
    method: "get",
    params,
  });
}

//用户地址添加
export function addUserAddress(data) {
  return request({
    url: "userAddress/web/addUserAddress",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

//用户地址删除
export function addressDelete(params) {
  return request({
    url: "userAddress/web/addressDelete",
    method: "get",
    params,
  });
}

//修改地址默认状态
export function defaultFlagUpdate(params) {
  return request({
    url: "userAddress/web/defaultFlagUpdate",
    method: "get",
    params,
  });
}

//历史订单列表
export function orderPojoList(params) {
  return request({
    url: "webOrder/web/orderPojoList",
    method: "get",
    params,
  });
} 

//删除订单
export function orderDelete(params) {
  return request({
    url: "webOrder/web/orderDelete",
    method: "get",
    params,
  });
} 
//历史订单详情
export function orderDetails(params) {
  return request({
    url: "webOrder/web/orderDetails",
    method: "get",
    params,
  });
} 

//档案分类查询
export function archivesCategoryNoPage(params) {
  return request({
    url: "archivesCategory/web/archivesCategoryNoPage",
    method: "get",
    params,
  });
} 
//档案分类查询
export function archivesList(params) {
  return request({
    url: "archives/web/archivesList",
    method: "get",
    params,
  });
} 
//档案详情
export function updateInformation(data) {
  return request({
    url: "webUser/web/updateInformation",
    method: "post",
    data,
  });
} 

//购物车列表
export function productShoppingCartList(params) {
  return request({
    url: "productShoppingCart/web/productShoppingCartList",
    method: "get",
    params,
  });
}
//关联色卡选项
export function selectProductColorList(params) {
  return request({
    url: "companyProductColor/web/selectProductColorList",
    method: "get",
    params,
  });
}

//修改购物车产品信息
export function updateProductShoppingCart(data) {
  return request({
    url: "productShoppingCart/web/updateProductShoppingCart",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

//购物车产品删除
export function deleteProductShoppingCart(params) {
  return request({
    url: "productShoppingCart/web/deleteProductShoppingCart",
    method: "get",
    params,
  });
}

//获取默认地址
export function getDefaultFlagAddress(params) {
  return request({
    url: "userAddress/web/getDefaultFlagAddress",
    method: "get",
    params,
  });
}

//更新购物车地址
export function updateShoppingCartAddress(data) {
  return request({
    url: "userAddress/web/updateShoppingCartAddress",
     method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}


//购物车产品提交订单
export function productShoppingCartToOrder(data) {
  return request({
    url: "productShoppingCart/web/productShoppingCartToOrder",
     method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}

//获取默认地址
export function getCountryAddressList() {
  return request({
    url: "userAddress/web/getCountryAddressList",
    method: "get",
  });
}
//获取省/州列表
export function getStatesAddressList(params) {
  return request({
    url: "userAddress/web/getStatesAddressList",
    method: "get",
    params,
  });
}

export function privacySubmit(data) {
  return request({
    url: "userInformation/privacySubmit",
     method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
}